var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M19.167 8.167A7.333 7.333 0 0011.834.833V7.98c0 .553.448 1.001 1.001 1.001h6.332v-.814zM9.542 1.75c.154 0 .307.004.459.012v7.152c0 1.106.896 2.003 2.002 2.003h6.236A8.709 8.709 0 119.542 1.75z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOS4xNjcgOC4xNjY1OEMxOS4xNjcgNC4xMTY1IDE1Ljg4MzggMC44MzMyNTIgMTEuODMzNyAwLjgzMzI1MlY3Ljk3OTk3QzExLjgzMzcgOC41MzMwNSAxMi4yODIgOC45ODE0IDEyLjgzNTEgOC45ODE0SDE5LjE2N1Y4LjE2NjU4Wk05LjU0MjMyIDEuNzUwMzlDOS42OTU5OSAxLjc1MDM5IDkuODQ4NzQgMS43NTQzNyAxMC4wMDA1IDEuNzYyMjNWOC45MTM3MkMxMC4wMDA1IDEwLjAxOTkgMTAuODk3MiAxMC45MTY2IDEyLjAwMzMgMTAuOTE2NkgxOC4yMzg4QzE4LjAwMDcgMTUuNTEzMiAxNC4xOTgyIDE5LjE2NzEgOS41NDIzMiAxOS4xNjcxQzQuNzMyODQgMTkuMTY3MSAwLjgzMzk4NCAxNS4yNjgyIDAuODMzOTg0IDEwLjQ1ODdDMC44MzM5ODQgNS42NDkyNCA0LjczMjg0IDEuNzUwMzkgOS41NDIzMiAxLjc1MDM5WiIgLz4KPC9zdmc+Cg==";
export { SvgPie as ReactComponent };